/* --------------------------------------------------------------------------
	Interiors

	Set right side nav menu sticky if large mode and it fits on
	screen. I think this is broken:
	 - position: sticky won't let a too big item not scroll
	 - the size calculation has a dependency with sub-nav.js and
	   it currently executes in wrong order.
	 - setting sticky doesn't let the menu stick for some reason

-------------------------------------------------------------------------- */

	"use strict";
	var $ = jQuery;
	import 'fastdom';
	import { addLargeListener, largeModeQuery } from '../base/page.js';
	var $sub,
	$header,
	$pageHeader;

	function initInterior() {
		$sub = $(".js-sub-nav");
		if ($sub.length) {
			$header = $(".js-header");
			$pageHeader = $(".js-page-header");

			addLargeListener(largeModeChange);
			largeModeChange();
		}
	}

	function largeModeChange() {
		if (largeModeQuery.matches) {
			enterLarge();
		} else {
			leaveLarge();
		}
	}

	function enterLarge() {
		// If sub nav fits on screen let it stay on screen (sticky).
		// Otherwise allow the user to scroll it with the main scrollbar.
		var sticky = null;

		fastdom.measure(function () {
			var visibleHeight = $(window).height() - $header.outerHeight();
			if ($pageHeader.length) {
				// Rare page that has a page header with a menu to the right and
				// a menu that fits on screen.
				//
				// 'subOffset' is an adjustment so the menu lines up with the page
				// header. See sub-nav.js
				//
				// FIXME: Sometimes sub-nav.js sets margin-top after this code.
				var subOffset = parseInt($sub.css("margin-top").replace(/[^-\d\.]/g, '')); // negative value
				visibleHeight -= $pageHeader.outerHeight() + subOffset;
			}
			var subHeight = $sub.outerHeight();
			sticky = visibleHeight >= subHeight;
		});

		fastdom.mutate(function () {
			if (sticky) {
				$sub.addClass("sticky");
			} else {
				$sub.removeClass("sticky");
			}
		});
	}

	function leaveLarge() {
		// Sub nav displays inline with a toggle button
		$sub.removeClass("sticky");
	}

	$(initInterior);
